import axios, { AxiosError } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { toFormData } from '../../utils/toFormData';
import { logError } from '../../utils/logError';
import { formatErrorKeys } from '../formatErrorKeys';
import { isAxiosError } from '../../utils/isAxiosError';
import { SignUpPayload, SignUpResponse } from './signUp.types';
import { TOO_MANY_REQUESTS_STATUS } from './signUp.constants';

export const signUp = async ({ email, password, username, firstName, lastName, funnel }: SignUpPayload) => {
    try {
        const url = pathfinder('users');

        const formData = toFormData({
            'user[email]': email,
            'user[password]': password,
            'user[username]': username,
            ...(firstName ? { 'user[firstName]': firstName } : {}),
            ...(lastName ? { 'user[lastName]': lastName } : {}),
            funnel,
        });

        const { data } = await axios.post<SignUpResponse>(url, formData);

        return {
            redirectUrl: data.redirect_url,
            errorKeys: formatErrorKeys(data.errorKeys || []),
            externalId: data.external_id,
        };
    } catch (error) {
        if (isAxiosError(error)) {
            const axiosError = error as AxiosError<SignUpResponse>;

            if (axiosError.response?.status === TOO_MANY_REQUESTS_STATUS) {
                return {
                    errorKeys: {
                        username: ['sign_up_rate_limit'],
                    } as const,
                };
            }

            if (axiosError.response?.data?.errorKeys) {
                return { errorKeys: formatErrorKeys(axiosError.response?.data.errorKeys || []) };
            }
        }

        logError({
            message: 'Error during sign up',
            error,
        });

        throw error;
    }
};
